export default "__VITE_ASSET__BoGWjuiG__"